module.exports = __webpack_public_path__ + "static/media/Data_insight_en_mo_2-2.11d887bd.svg";